<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="960px"
    top="4vh"
    append-to-body
    custom-class="interface-source-dialog"
    @update:visible="updateVisible"
    @opened="handleOpened"
    @closed="handleClosed">
    <div v-loading="loading" class="source-dialog-body">
      <div v-if="filePath" class="file-path">
        <span class="ele-text-secondary">文件路径：</span>
        <code>{{ filePath }}</code>
        <el-tag v-if="codeName" size="mini" type="info" class="exists-tag">{{ codeName }}</el-tag>
        <el-tag v-if="!fileExists" size="mini" type="warning" class="exists-tag">文件不存在</el-tag>
      </div>
      <php-code-editor
        v-if="!loadError"
        ref="editor"
        :key="editorKey"
        v-model="content"
        height="calc(72vh - 140px)"
        :read-only="false" />
      <div v-else class="empty-tip">{{ loadError }}</div>
    </div>
    <div slot="footer">
      <el-button :disabled="loading || !!loadError" @click="loadSource">刷新</el-button>
      <el-button type="primary" :loading="saving" :disabled="!!loadError" @click="saveSource">保存</el-button>
      <el-button @click="updateVisible(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PhpCodeEditor from '@/components/PhpCodeEditor.vue';

const TYPE_TITLES = {
  in: '代收接口',
  out: '代付接口',
  query: '订单查询',
  balance: '余额查询'
};

export default {
  name: 'InterfaceSourceDialog',
  components: { PhpCodeEditor },
  props: {
    visible: Boolean,
    uplistId: {
      type: [Number, String],
      default: 0
    },
    sourceType: {
      type: String,
      default: 'in'
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      content: '',
      filePath: '',
      fileExists: false,
      codeName: '',
      loadError: '',
      editorKey: 0
    };
  },
  computed: {
    dialogTitle() {
      return TYPE_TITLES[this.sourceType] || '控制器源码';
    }
  },
  methods: {
    updateVisible(val) {
      this.$emit('update:visible', val);
    },
    handleOpened() {
      this.loadSource();
    },
    handleClosed() {
      this.content = '';
      this.filePath = '';
      this.fileExists = false;
      this.codeName = '';
      this.loadError = '';
      this.editorKey += 1;
    },
    loadSource() {
      if (!this.uplistId) {
        this.loadError = '渠道信息无效';
        return;
      }
      this.loading = true;
      this.loadError = '';
      this.$http.get('/Uplist/getInterfaceSource', {
        params: {
          uplist_id: this.uplistId,
          type: this.sourceType
        }
      }).then((res) => {
        this.loading = false;
        if (res.data.code === 0 && res.data.data) {
          const data = res.data.data;
          this.content = data.content || '';
          this.filePath = data.path;
          this.fileExists = !!data.exists;
          this.codeName = data.code_name;
          this.editorKey += 1;
          this.$nextTick(() => {
            if (this.$refs.editor) {
              this.$refs.editor.remount();
            }
          });
          return;
        }
        this.loadError = res.data.msg || '加载失败';
      }).catch((e) => {
        this.loading = false;
        this.loadError = e.message;
      });
    },
    saveSource() {
      if (!this.uplistId) {
        return;
      }
      const content = this.$refs.editor ? this.$refs.editor.getValue() : this.content;
      if (!content.trim()) {
        this.$message.warning('控制器代码不能为空');
        return;
      }
      this.saving = true;
      this.$http.post('/Uplist/saveInterfaceSource', {
        uplist_id: this.uplistId,
        type: this.sourceType,
        content
      }).then((res) => {
        this.saving = false;
        if (res.data.code === 0) {
          this.$message.success(res.data.msg || '保存成功');
          if (res.data.data) {
            this.filePath = res.data.data.path || this.filePath;
            this.codeName = res.data.data.code_name || this.codeName;
            this.fileExists = true;
          }
          this.$emit('done');
          return;
        }
        this.$message.error(res.data.msg || '保存失败');
      }).catch((e) => {
        this.saving = false;
        this.$message.error(e.message);
      });
    }
  }
};
</script>

<style scoped>
.source-dialog-body {
  min-height: 360px;
}

.file-path {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.6;
  word-break: break-all;
}

.file-path code {
  color: #409eff;
  background: #f4f8ff;
  padding: 2px 6px;
  border-radius: 3px;
}

.exists-tag {
  margin-left: 8px;
  vertical-align: middle;
}

.empty-tip {
  padding: 80px 12px;
  text-align: center;
  color: #909399;
  font-size: 13px;
}
</style>
